import {UUID} from 'app/utils/uuid';

export enum TargetVersionType {
  LIVE = 'LIVE',
  LAST_PUBLISHED = 'LAST_PUBLISHED',
}

export class InternalReferenceState {
  public id: UUID;
  public sourceDocumentId: UUID;
  public targetDocumentId: UUID;
  public targetVersion: TargetVersionType;
  public createdAt: number;
  public createdBy: UUID;

  constructor(
    id: UUID,
    sourceDocumentId: UUID,
    targetDocumentId: UUID,
    targetVersion: TargetVersionType,
    createdAt: number,
    createdBy: UUID
  ) {
    this.id = id;
    this.sourceDocumentId = sourceDocumentId;
    this.targetDocumentId = targetDocumentId;
    this.targetVersion = targetVersion;
    this.createdAt = createdAt;
    this.createdBy = createdBy;
  }

  public static deserialise(json: any): InternalReferenceState {
    return new InternalReferenceState(
      UUID.orThrow(json.id),
      UUID.orThrow(json.sourceDocumentId),
      UUID.orThrow(json.targetDocumentId),
      json.targetVersion,
      json.createdAt,
      UUID.orThrow(json.createdBy)
    );
  }

  public serialise(): any {
    return {
      id: this.id ? this.id.value : null,
      sourceDocumentId: this.sourceDocumentId ? this.sourceDocumentId.value : null,
      targetDocumentId: this.targetDocumentId ? this.targetDocumentId.value : null,
      targetVersion: this.targetVersion,
      createdAt: this.createdAt,
      createdBy: this.createdBy ? this.createdBy.value : null,
    };
  }
}
